import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SessionService } from '../../Util/Session/session.service';

@Injectable({
  providedIn: 'root'
})
export class AttendanceService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) { 
    environment.API_URL = this.session.GetUserDetails().ApiUrl;
  }

  AttendanceRuleLoadGet(AttendaceDetail: any) {
    return this.http.post<any>(environment.API_URL + `AttendanceRuleLoad/Get`,
      this.session.SetClass(AttendaceDetail)
    ).pipe(map(response => {
      if(response.Error_Code == '11' || response.Error_Code == '02'){
        this.session.End();
      }else{
        return response;
      }
    }));
  }

  AttendanceRuleUpdate(AttendaceDetail: any) {
    return this.http.post<any>(environment.API_URL + `AttendanceRule/Update`,
      this.session.SetClass(AttendaceDetail)
    ).pipe(map(response => {
      if(response.Error_Code == '11'){
        this.session.End();
      }else{
        return response;
      }
    }));
  }

  AttendanceInOutSave(AttendaceDetail: any) {
    return this.http.post<any>(environment.API_URL + `DailyAttendance/InOutSave`,
      this.session.SetClass(AttendaceDetail)
    ).pipe(map(response => {
      if(response.Error_Code == '11'){
        this.session.End();
      }else{
        return response;
      }
    }));
  }

  GetDailyAttendanceInOut(AttendaceDetail: any) {
    return this.http.post<any>(environment.API_URL + `DailyAttendanceInOut/Load`,
      this.session.SetClass(AttendaceDetail)
    ).pipe(map(response => {
      if(response.Error_Code == '11'){
        this.session.End();
      }else{
        return response;
      }
    }));
  }
  
  GetAttendanceDetails(AttendaceDetail: any) {
    return this.http.post<any>(environment.API_URL + `GetAttendance/Details`,
      this.session.SetClass(AttendaceDetail)
    ).pipe(map(response => {
      if(response.Error_Code == '11'){
        this.session.End();
      }else{
        return response;
      }
    }));
  }

  GetDailyAttendanceInOutHistory(AttendaceDetail: any) {
    return this.http.post<any>(environment.API_URL + `DailyAttendanceInOutHistoryLoad/Load`,
      this.session.SetClass(AttendaceDetail)
    ).pipe(map(response => {
      if(response.Error_Code == '11'){
        this.session.End();
      }else{
        return response;
      }
    }));
  }
}
